import { Injectable } from "@angular/core";
import { Resolve } from '@angular/router';

import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Broker } from '../../models/broker';
import { UsersService } from '../../../services/users/users.service';

@Injectable()
export class BrokerResolver implements Resolve<Broker> {

  constructor(
    private authenticationService: AuthenticationService,
    private usersService: UsersService
  ) {}
  
  resolve(): Promise<any> {
    if (this.authenticationService.isLoggedIn()) {
      if (this.usersService.primaryBroker) {
        return Promise.resolve(this.usersService.primaryBroker);
      } else {
        return this.usersService.getBrokerForCustomer().toPromise().then(
          broker => {
            this.usersService.setBroker(broker);
            return Promise.resolve(this.usersService.primaryBroker);
          }).catch((error: any) => {
            return '';
          }
        );
      }
    }
  }
}
